module.exports = __webpack_public_path__ + "static/media/Logo.a107b39e.png";